export enum SlhNavigationSidebarState {
  EXPANDED = "expanded",
  HIDDEN = "hidden",
}
